<div class="container">
  <div class="header">
    <img (click)="downloadBoleto()" class="header__download-btn" src="/assets/images/simbolos/downloadDark.svg"
      alt="Download" matTooltip="Baixar Documento">
    <img (click)="fecharModal()" src="/assets/images/simbolos/closeIcon.svg" alt="Fechar Modal">
  </div>
  <pdf-viewer [src]="pdf" [render-text]="true" [original-size]="false" [zoom]="0.9"
    style="width: 100%; height: 80vh"></pdf-viewer>
</div>
